import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "segmentBuilder",
    "wheelWallpaperReducer",
    "gallery",
    "codeblockStyles",
    "wheelSettings",
    "galleryPopup",
    "nonAuthenticatedModal",
    // ISP-9999 (gordon-0916-stg-notifications-deleted-come-back-next-day): a
    // deleted-server-side notification stayed visible on this page's next
    // visit because the feed slice was persisted to localStorage and nothing
    // ever pruned a deleted row from that cached copy client-side -- the
    // page mounted, rendered the stale persisted array first, and only
    // overwrote it once its own fetch resolved. The feed is cheap to refetch
    // and always owner/session-scoped, so there is no reason to cache it
    // across reloads at all.
    "notifications",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

// STAGING PORT GAP (2026-09-18): Navbar, ProfileMenu and Settings > Delete
// Account all import this, but it was never ported to this branch, so the
// import resolved to `undefined` and logging out / deleting the account threw.
// Restored verbatim from origin/dev.
//
// Wipe the redux-persist snapshot so a logged-out tab cannot rehydrate the
// previous session. persistor.purge() is the redux-persist-blessed removal; the
// direct removeItem is a synchronous belt-and-braces in case the async purge
// write is still pending when the page navigates or reloads.
const purgePersistedState = async () => {
  try {
    await persistor.purge();
  } catch (e) {
    // ignore - fall through to the direct removal below
  }
  try {
    // persistConfig.key === "root" => storage key is `persist:root`.
    window.localStorage.removeItem(`persist:${persistConfig.key}`);
  } catch (e) {
    // localStorage unavailable (SSR / privacy mode) - nothing to purge
  }
};

export { store, persistor, persistConfig, purgePersistedState };
